import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { getRouter } from "./router";
import { authStore } from "./lib/auth-store";
import "./styles.css";

async function main() {
  // Initialize auth state from stored tokens
  await authStore.init();

  const router = getRouter();

  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error("Root element not found");

  createRoot(rootElement).render(<RouterProvider router={router} />);
}

main();
